// 能下拉刷新的分页的setup
import { onBeforeUnmount } from 'vue'
import { UploadFile, ImagesQuery, ImageInfo } from '@/types/public'
import { UploadImages, GetImagesInfo } from '@/apis/public'
import { Toast } from 'vant'
import Compressor from 'compressorjs'

export default function uploadFilesSetup(): {
  uploadFiles: (files: UploadFile[]) => Promise<{ fileStrArr: string[]; files: UploadFile[] }>
  getFiles: (
    files: UploadFile[],
    imgIds: string[]
  ) => Promise<{ fileObjArr: ImageInfo[]; files: UploadFile[] }>
  _ts: number
} {
  // 图片压缩
  const imageCompress = async (file: File) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 4096,
        maxHeight: 4096,
        checkOrientation: false,
        success(result) {
          resolve({
            type: 'success',
            file: result,
          })
        },
        error(err) {
          reject({
            type: 'error',
            msg: err.message,
          })
        },
      })
    })
  }
  const uploadFiles = async (files: UploadFile[]) => {
    const ts = _ts
    try {
      const formData: FormData = new FormData()
      const len = files.length
      for (let i = 0; i < len; i++) {
        const indexResult: any = await imageCompress(files[i].file)
        if (indexResult.type == 'success') {
          formData.append('images[]', indexResult.file)
        }
      }
      const result: string[] = await UploadImages(formData)
      if (ts !== _ts) return
      // getFiles(files, result)
      return { fileStrArr: result, files }
      // console.log(result)
    } catch (err: unknown) {
      if (ts !== _ts) return
      const message: string = (err as { message: string }).message
      Toast(message)
      console.error(message)
    }
  }
  const getFiles = async (files: UploadFile[], imgIds: string[]) => {
    const ts = _ts
    try {
      const obj: ImagesQuery = {
        res_uids: imgIds,
        width: 150,
        height: 150,
      }
      const result: ImageInfo[] = await GetImagesInfo(obj)
      if (ts !== _ts) return

      return {
        fileObjArr: result.map((it) => {
          it.isImage = true
          return it
        }),
        files,
      }
      // files.forEach((it) => {
      //   it.status = 'done'
      //   it.message = '上传完成'
      // })
      // console.log(result)
    } catch (err: unknown) {
      if (ts !== _ts) return
      const message: string = (err as { message: string }).message
      console.error(message)
    }
  }
  let _ts: number = Date.now()
  onBeforeUnmount(() => {
    _ts = 0
  })

  return {
    uploadFiles,
    getFiles,
    _ts,
  }
}
